import { registerChartBuilder } from '@/chart/restructured-charts/chart-builder-factory';
import { areamapChartBuilder } from '@/chart/restructured-charts/areamap-chart/areamap-chart-builder';

let areamapRegistered = false;

export const registerAreamap = () => {
  if (areamapRegistered) {
    return;
  }
  areamapRegistered = true;
  registerChartBuilder('areamap', areamapChartBuilder);
};
